import axios from 'axios';
import store from '@/store';
import router from '@/router'

let api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080/api/v1'
});

api.interceptors.request.use(
    config => {
        if ((store.state.auth.token) && (store.state.auth.token.token))
            config.headers['Authorization'] = `Bearer ${store.state.auth.token.token}`;
        config.headers['Accept-Language'] = localStorage.getItem('lang') || 'de';
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 401) {
        store.dispatch('auth/logout')
        router.push('/login')
    }
    return Promise.reject(error)
})

export default api